import { memo } from "react"
import { useParams } from "react-router"
import { getScheduleDraft } from "./controller/get-schedule-draft"
import { getDraftAmendsByReferenceIdAndType } from "authoring/routes/project/amends/controller/get-draft-amends-by-reference-id-and-type"
import { AuthoringAmendsType } from "../../../lib/enum/authoring-amends-type.mjs"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { buildAuthoringAuthorNotesView } from "./lib/authoring-author-notes-data"
import { RejectionAlert } from "./rejection-alert"
import { If } from "lib/@components/switch"
import { AuthoringScheduleEditorAlert } from "./schedule-editor"
import { createDraftId } from "authoring/routes/project/lib/project-utils"

export const RejectionAlertPlug = memo(function RejectionAlertPlug() {
    const { projectId, scheduleId } = useParams()
    const draftId = createDraftId(projectId, scheduleId)

    const draftData = getScheduleDraft.useResultsOnce({ projectId, scheduleId })
    const amends = getDraftAmendsByReferenceIdAndType.useResultsOnce(
        draftId,
        AuthoringAmendsType.AUTHORING_AMENDS,
        undefined,
        projectId
    )

    if (!draftId || !draftData || !amends) return null

    const showRejection = draftData?.status === DraftStatus.REJECTED || draftData?.status === DraftStatus.EDITING
    if (!showRejection) return null

    const currentReviewCycle = draftData?.reviewCycle ?? 1
    const { cycleGroups } = buildAuthoringAuthorNotesView({
        records: amends ?? [],
        currentReviewCycle,
        scheduleId,
        draftTasks: draftData?.draft?.tasks ?? [],
    })

    const latestRejectedReviewCycle = cycleGroups.find((cycle) => Boolean(cycle?.rejection)) ?? null

    return (
        <AuthoringScheduleEditorAlert.Plug>
            <If truthy={latestRejectedReviewCycle}>
                <RejectionAlert latestRejectedReviewCycle={latestRejectedReviewCycle} />
            </If>
        </AuthoringScheduleEditorAlert.Plug>
    )
})
